// TODO make the variables and listeners a list
// to handle with more than one element
// and get index to prevent conflit

export default {
  data () {
    return {
      xDown: null,
      yDown: null
    }
  },
  methods: {
    addSwipeListener (domId, callback) {
      console.log(domId)
      let dom  = document.getElementById(domId)
      console.log(dom)
      dom.addEventListener('touchstart', (evt) => {this.handleTouchStart(evt)}, false)
      dom.addEventListener('touchmove', (evt) => {this.handleTouchMove(evt, callback)}, false)
    },
    removeSwipeLister (domId, callback) {
      let dom  = document.getElementById(domId)
      dom.removeEventListener('touchstart', (evt) => {this.handleTouchStart(evt)}, false)
      dom.removeEventListener('touchmove', (evt) => {this.handleTouchMove(evt, callback)}, false)
    },
    handleTouchStart(evt) {                                         
      this.xDown = evt.touches[0].clientX                               
      this.yDown = evt.touches[0].clientY                                  
    },
    handleTouchMove(evt, callback) {
      if (!this.xDown || !this.yDown) {
        return
      }
      var xUp = evt.touches[0].clientX                              
      var yUp = evt.touches[0].clientY
      var xDiff = this.xDown - xUp
      var yDiff = this.yDown - yUp
      if(Math.abs( xDiff )+Math.abs( yDiff )>150){ //to deal with to short swipes

      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
        if ( xDiff > 0 ) {/* left swipe */ 
          callback('left')
        } else {/* right swipe */
          callback('right')
        }                       
      } else {
        if ( yDiff > 0 ) {/* up swipe */
          callback('up');
        } else { /* down swipe */
          callback('down')
        }                                                                 
      }
      /* reset values */
      this.xDown = null;
      this.yDown = null;
      }
    }
  }
}